import type { ReactElement } from "react";
import { CmtsCapaContainer } from "../../core/containers/domain/rcacapaRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsCapaContainer runtime={props.runtime} />;
}

export default Component;
